import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
	selector: 'app-chip',
	imports: [SharedModule],
	templateUrl: './chip.component.html',
	styleUrl: './chip.component.scss',
})
export class ChipComponent {
	@Input() label = '';
	@Input() removable = true;
	@Input() size: 'small' | 'large' = 'small';

	@Output() onRemove = new EventEmitter<void>();

	onChipRemove() {
		this.onRemove.emit();
	}
}
